import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';

import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { AppConfig } from 'app/app.config';
import { Role } from 'app/shared/common/role';
import { DataService } from 'app/shared/services/dataService';
import { UserAccess } from 'app/shared/models/userModel';
import { Common } from 'app/shared/utility/common';
import { EventTypes } from 'app/shared/utility/constants';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent extends BaseComponent implements OnInit {
  show: boolean = false;
  publishedUserQuery: any = null;
  currentSort: any = { field: null, forward: null };
  users: UserAccess[] = [];
  activeAndPendingUsers: UserAccess[] = []; 
  inactiveUsers: UserAccess[] = []; 
  role = Role;

  constructor(private dataServices: DataService, appConfig: AppConfig) {
    super(appConfig);
  }

  ngOnInit() {
    this.getUsers();
  }

  userSelected(user) {
    EventAggregator.publish(EventList.userSelected, user);
  }

  sort(field: string, type: string) {
    if (this.currentSort.field === field) {
      this.currentSort.forward = !this.currentSort.forward;
    } else {
      this.currentSort = { field: field, forward: true };
    }
    this.applySort();
  }

  applySort() {
    const type = 'string'; 
    const field = this.currentSort.field;
    const sortDirection = this.currentSort.forward ? 1 : -1;
  
    const sorter = (a, b) => {
      let valueA = a[field];
      let valueB = b[field];
  
      // Special handling for computedRole
      if (field === 'computedRole') {
        valueA = this.getDisplayRole(a.RoleNames);
        valueB = this.getDisplayRole(b.RoleNames);
      }
  
      if (type === 'string') {
        return valueA.localeCompare(valueB) * sortDirection;
      } else {
        return (valueA - valueB) * sortDirection;
      }
    };
  
    this.activeAndPendingUsers.sort(sorter);
    this.inactiveUsers.sort(sorter);
  
    this.activeAndPendingUsers = [...this.activeAndPendingUsers];
    this.inactiveUsers = [...this.inactiveUsers];
  }
  


    edit(user: UserAccess) {
      const originalUser = { ...user };
      EventAggregator.publish(EventList.popupTriggered, {
        type: EventTypes.EditUser,
        value: user
      });

      const subscription = EventAggregator.get(EventList.userUpdated).subscribe(updatedUser => {
          if (originalUser.Status !== updatedUser.Status || JSON.stringify(originalUser.Roles) !== JSON.stringify(updatedUser.Roles)) {
            this.refreshUsers();
          }
          subscription.unsubscribe();
      });
  }
  refreshUsers() {
    this.dataServices.getUsers()
      .then(response => {
        this.users = response;
        this.filterUsers(); // Refresh filtered user lists
      })
      .catch(err => {
        console.error('Failed to refresh users:', err);
      });
  }
    
    getUsers() {
      this.dataServices.getUsers()
      .then(response => {
        this.users = response;
        this.filterUsers();  // Call to new method to filter users
        this.show = true;
      })
      .catch(err => {
        this.show = false;
      });
    }
  
    filterUsers() {
      this.activeAndPendingUsers = this.users.filter(user => user.Status === 'Active' || user.Status === 'Pending');
      this.inactiveUsers = this.users.filter(user => user.Status === 'Inactive');
    }

    downloadUsers() {

      let csvContent = 'data:text/csv;charset=utf-8,';
       let usersDownload = [['Name', ' Email', 'Registration Status', 'Role', 'Counties']];
      this.users.forEach((user) => {
        usersDownload.push([user.FirstName + ' ' + user.LastName, user.Email || 'Not Available', user.Status, user.RoleNames.join("|"), user.Groups]);
      });
      usersDownload.forEach(function(rowArray){
        let row = rowArray.join(',');
        csvContent += row + '\r\n';
     });
      let encodedUri = encodeURI(csvContent);

      let link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'userList.csv');
      document.body.appendChild(link); // Required for FF
      link.click(); // This will download the data file named "my_data.csv".
    }
    getDisplayRole(RoleNames: string[]): string {
      if (RoleNames.includes('ADMIN')) {
        return 'Admin';
      } else if (RoleNames.includes('USER')) {
        return 'User';
      }
      return ''; // Return empty if neither 'ADMIN' nor 'USER' is found
    }
    
}

